'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useEffect, startTransition } from 'react';
import { Menu, X, Search, Moon, Sun, User, LogOut, LayoutDashboard } from 'lucide-react';
import { useTheme } from 'next-themes';
import { CATEGORIES } from '@/lib/categories';
import { useAuth } from '@/components/auth/AuthProvider';
export function Header() {
  const $ = _c(49);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    theme,
    setTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  const {
    user,
    isAdmin,
    login,
    logout
  } = useAuth();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 20);
      };
      startTransition(() => {
        setMounted(true);
      });
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = `sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-lg border-b border-gray-200 dark:border-gray-800 shadow-sm" : "bg-transparent"}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/" className="flex items-center space-x-2 group"><div className="w-10 h-10 rounded-lg gradient-primary flex items-center justify-center transform group-hover:scale-105 transition-transform"><span className="text-white font-bold text-xl">T</span></div><span className="font-bold text-xl md:text-2xl gradient-text-primary">Tech-Knowlogia</span></Link>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/" className="text-xs lg:text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">Home<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
    t5 = CATEGORIES.map(_temp);
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/about" className="text-xs lg:text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">About<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden md:flex items-center space-x-4 lg:space-x-8">{t4}{t5}{t6}<Link href="/contact" className="text-xs lg:text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">Contact<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button aria-label="Search" className="p-2 rounded-lg hover:bg-muted transition-colors"><Search className="w-5 h-5" aria-hidden="true" /></button>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== mounted || $[9] !== setTheme || $[10] !== theme) {
    t9 = mounted && <button onClick={() => setTheme(theme === "dark" ? "light" : "dark")} aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"} className="p-2 rounded-lg hover:bg-muted transition-colors">{theme === "dark" ? <Sun className="w-5 h-5" aria-hidden="true" /> : <Moon className="w-5 h-5" aria-hidden="true" />}</button>;
    $[8] = mounted;
    $[9] = setTheme;
    $[10] = theme;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isAdmin || $[13] !== login || $[14] !== logout || $[15] !== mounted || $[16] !== user) {
    t10 = mounted && user ? <div className="flex items-center space-x-2">{isAdmin && <Link href="/admin-dashboard" className="p-2 rounded-lg hover:bg-muted transition-colors text-primary" aria-label="Admin Dashboard" title="Admin Dashboard"><LayoutDashboard className="w-5 h-5" aria-hidden="true" /></Link>}<button onClick={logout} className="p-2 rounded-lg hover:bg-muted transition-colors text-red-500" aria-label="Log out" title="Logout"><LogOut className="w-5 h-5" aria-hidden="true" /></button></div> : <button onClick={login} className="p-2 rounded-lg hover:bg-muted transition-colors" aria-label="Log in" title="Login"><User className="w-5 h-5" aria-hidden="true" /></button>;
    $[12] = isAdmin;
    $[13] = login;
    $[14] = logout;
    $[15] = mounted;
    $[16] = user;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/newsletter" className="px-4 py-2 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors">Subscribe</Link>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t9) {
    t12 = <div className="hidden md:flex items-center space-x-4">{t8}{t9}{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isMenuOpen) {
    t13 = () => setIsMenuOpen(!isMenuOpen);
    $[22] = isMenuOpen;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = isMenuOpen ? "Close menu" : "Open menu";
  let t15;
  if ($[24] !== isMenuOpen) {
    t15 = isMenuOpen ? <X className="w-6 h-6" aria-hidden="true" /> : <Menu className="w-6 h-6" aria-hidden="true" />;
    $[24] = isMenuOpen;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== isMenuOpen || $[27] !== t13 || $[28] !== t14 || $[29] !== t15) {
    t16 = <button onClick={t13} className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors" aria-label={t14} aria-expanded={isMenuOpen} aria-controls="mobile-menu">{t15}</button>;
    $[26] = isMenuOpen;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t16) {
    t17 = <div className="flex items-center justify-between h-16 md:h-20 gap-2 md:gap-4">{t3}{t7}{t12}{t16}</div>;
    $[31] = t12;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== isAdmin || $[35] !== isMenuOpen || $[36] !== login || $[37] !== logout || $[38] !== mounted || $[39] !== setTheme || $[40] !== theme || $[41] !== user) {
    t18 = isMenuOpen && <div id="mobile-menu" className="md:hidden border-t border-gray-200 dark:border-gray-800" role="dialog" aria-modal="true" aria-label="Mobile Navigation"><div className="py-4 space-y-4"><Link href="/" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Home</Link>{CATEGORIES.map(category_0 => <Link key={category_0.slug} href={`/${category_0.slug}`} className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>{category_0.name}</Link>)}<Link href="/about" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>About</Link><Link href="/contact" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Contact</Link>{mounted && user ? <>{isAdmin && <Link href="/admin-dashboard" className="block px-4 py-2 text-sm font-medium text-primary hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Admin Dashboard</Link>}<button onClick={() => {
            logout();
            setIsMenuOpen(false);
          }} className="block w-full text-left px-4 py-2 text-sm font-medium text-red-500 hover:bg-muted rounded-lg transition-colors">Logout</button></> : <button onClick={() => {
          login();
          setIsMenuOpen(false);
        }} className="block w-full text-left px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors">Login</button>}<div className="flex items-center space-x-4 px-4 pt-4 border-t border-gray-200 dark:border-gray-800"><button aria-label="Search" className="p-2 rounded-lg hover:bg-muted transition-colors"><Search className="w-5 h-5" aria-hidden="true" /></button>{mounted && <button onClick={() => setTheme(theme === "dark" ? "light" : "dark")} aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"} className="p-2 rounded-lg hover:bg-muted transition-colors">{theme === "dark" ? <Sun className="w-5 h-5" aria-hidden="true" /> : <Moon className="w-5 h-5" aria-hidden="true" />}</button>}</div><div className="px-4"><Link href="/newsletter" className="block w-full px-4 py-2 text-center rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors" onClick={() => setIsMenuOpen(false)}>Subscribe</Link></div></div></div>;
    $[34] = isAdmin;
    $[35] = isMenuOpen;
    $[36] = login;
    $[37] = logout;
    $[38] = mounted;
    $[39] = setTheme;
    $[40] = theme;
    $[41] = user;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t17 || $[44] !== t18) {
    t19 = <nav className="container" aria-label="Main navigation">{t17}{t18}</nav>;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t2) {
    t20 = <header className={t2}>{t19}</header>;
    $[46] = t19;
    $[47] = t2;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
}
function _temp(category) {
  return <Link key={category.slug} href={`/${category.slug}`} className="text-xs lg:text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">{category.name}<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
}